let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("a3In5")).then(() => parcelRequire('jd2D8'));